import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const savedViewSerializeMap: SerializeMap<SavedView> = {
  content: "content",
  id: "id",
  isGlobal: "is_global",
  name: "name",
  ownerId: "owner_id",
  ownerType: "owner_type",
  table: "table",
  filters: "filters",
  permissions: "permissions",
};

export const serializeSavedView = buildSerializer<SavedView>(
  savedViewSerializeMap,
  "savedView",
);
export const deserializeSavedView = buildDeserializer(
  savedViewSerializeMap,
  "savedView",
);
